import type { GeometryInputs } from "./types";

export const defaultGeometryInputs: GeometryInputs = {
  aMass: 3.2,
  zMeasure: 5.579029745987514,
  angle: 110
};
